import { InjectionToken } from '@angular/core';

export class AppConfig {
  apiBaseUrl: string;
  cloudApiBaseUrl: string;
  zitadelBaseUrl: string;
  mailerBaseUrl: string;
  mailerAud?: string;
  appName: string;
  enableServiceWorker: boolean;
  pdfExporterBaseUrl: string;
  externalAccountingSyncBaseUrl: string;
  googleMapsApiKey: string;
  googleMapsMapId?: string;
  version: {
    version: string;
    commit: string;
  };
  sentry: {
    enabled: boolean;
    dsn: string;
    release: string;
    tunnel?: string;
    environment: string;
    captureExceptionsInErrorHandler: boolean;
    callOriginalErrorHandler: boolean;
    showReportDialog: boolean;
    replay: {
      enabled: boolean;
      errorSampleRate?: number;
    }
    tracing: {
      enabled: boolean;
      sampleRate?: number;
    }
  };
}

export const DEFAULT_GOOGLE_MAPS_MAP_ID = 'DEMO_MAP_ID';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export let config: AppConfig;

export function setConfig(newConfig: AppConfig) {
  config = newConfig;
}

export function getConfig() {
  return config;
}
